import { render, staticRenderFns } from "./IndustryRank.vue?vue&type=template&id=061e3a6b&scoped=true"
import script from "./IndustryRank.vue?vue&type=script&lang=ts"
export * from "./IndustryRank.vue?vue&type=script&lang=ts"
import style0 from "./IndustryRank.vue?vue&type=style&index=0&id=061e3a6b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061e3a6b",
  null
  
)

export default component.exports